<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a>
          <i class="fa fa-ticket"></i>
          Tickets
        </a>
      </li>
    </ul>
  </div>
  <a class="bm-btn bm-btn-ghost rounded-2 bm-text-100" [routerLink]="['/', 'ticket', 'neu']">
    <i class="fa fa-plus"></i>
    Ticket erstellen
  </a>
</div>
<div class="page-content page-frame overflow-y-auto">
  <form [formGroup]="form" class="page-sheet max-w-7xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-3">
      <fieldset class="bm-fieldset md:col-span-2 p-4">
        <legend class="bm-fieldset-legend text-lg">Ticketsuche</legend>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
          <div class="bm-fieldset">
            <label class="bm-fieldset-label">Auftragsnummer</label>
            <input class="bm-input w-full" type="text" [formControl]="form.controls.order_number" />
          </div>
          <div class="bm-fieldset">
            <label class="bm-fieldset-label">Externe Auftragsnummer</label>
            <input class="bm-input w-full" type="text" [formControl]="form.controls.external_order_number" />
          </div>
          <div class="bm-fieldset">
            <label class="bm-fieldset-label">Fehlertext</label>
            <input class="bm-input w-full" type="text" [formControl]="form.controls.fault_description" />
          </div>
          <div class="bm-fieldset col-start-1">
            <label class="bm-fieldset-label">Rechnungsnummer</label>
            <input class="bm-input w-full" type="text" [formControl]="form.controls.invoice_number" />
          </div>
          <div class="bm-fieldset">
            <label class="bm-fieldset-label">Rechnungsnummer Partner</label>
            <input class="bm-input w-full" type="text" [formControl]="form.controls.invoice_number_partner" />
          </div>

          <div class="bm-fieldset">
            <label class="bm-fieldset-label"> Erstellungsdatum </label>
            <div class="bm-join">
              <div class="bm-join-item bm-input w-full">
                <input
                  class="w-full bm-join-item"
                  [formControl]="form.controls.create_date_from"
                  [matDatepicker]="pickerCreateFrom"
                  placeholder="von"
                  (click)="pickerCreateFrom.open()" 
                  (focus)="pickerCreateFrom.open()"
                />
                <mat-datepicker #pickerCreateFrom />
                <input
                  class="w-full bm-join-item"
                  [formControl]="form.controls.create_date_to"
                  [matDatepicker]="pickerCreateTo"
                  placeholder="bis"
                  (click)="pickerCreateTo.open()" 
                  (focus)="pickerCreateTo.open()"
                />
                <mat-datepicker #pickerCreateTo [startAt]="form.controls.create_date_from.value" />
                @if (form.controls.create_date_from.value || form.controls.create_date_to.value) {
                  <span (click)="clearCreateDate()" class="cursor-pointer">
                    <fa-icon [icon]="['far', 'times']" />
                  </span>
                }
              </div>
            </div>
            <div class="flex flex-row gap-1">
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('created', 'today')"
              >
                heute
              </button>
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('created', 'thisweek')"
              >
                diese Woche
              </button>
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('created', 'nextweek')"
              >
                nächste Woche
              </button>
            </div>
          </div>

          <div class="bm-fieldset">
            <label class="bm-fieldset-label"> Einsatzdatum </label>
            <div class="bm-join">
              <div class="bm-join-item bm-input w-full">
                <input
                  class="w-full bm-join-item"
                  [formControl]="form.controls.operation_date_from"
                  [matDatepicker]="pickerOpFrom"
                  placeholder="von"
                  (click)="pickerOpFrom.open()" 
                  (focus)="pickerOpFrom.open()"
                />
                <mat-datepicker #pickerOpFrom />

                <input
                  class="w-full bm-join-item"
                  [formControl]="form.controls.operation_date_to"
                  [matDatepicker]="pickerOpTo"
                  placeholder="bis"
                  (click)="pickerOpTo.open()" 
                  (focus)="pickerOpTo.open()"
                />
                <mat-datepicker #pickerOpTo [startAt]="form.controls.operation_date_from.value" />
                 @if (form.controls.operation_date_from.value || form.controls.operation_date_to.value) {
                  <span (click)="clearOperationDate()" class="cursor-pointer">
                    <fa-icon [icon]="['far', 'times']" />
                  </span>
                }
              </div>
            </div>
            <div class="flex flex-row gap-1">
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('operation', 'today')"
              >
                heute
              </button>
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('operation', 'thisweek')"
              >
                diese Woche
              </button>
              <button
                type="button"
                tabindex="-1"
                class="bm-btn bm-btn-xs bm-btn-primary"
                (click)="setRange('operation', 'nextweek')"
              >
                nächste Woche
              </button>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Projektauswahl</legend>
        <label class="bm-fieldset-label">Projekt</label>
        <ng-select class="w-full" [items]="projects" bindLabel="name" bindValue="id" [formControl]="form.controls.project_id">
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermProject">
            @if (item.name.toLowerCase().includes(searchTermProject.toLowerCase())) {
              <div>
                {{ item.name }}
              </div>
            }
          </ng-template>
        </ng-select>

        @if (currentProject) {
          <label class="bm-fieldset-label">Status</label>
          <ng-select
            class="w-full"
            [items]="currentProject.status"
            bindLabel="name"
            bindValue="id"
            [formControl]="form.controls.status_id"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              <div *ngIf="item.name.toLowerCase().includes(searchTermStatus.toLowerCase())">
                {{ item.name }}
              </div>
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">Priorität</label>
          <ng-select
            class="w-full"
            [items]="currentProject.priorities"
            bindLabel="name"
            bindValue="id"
            [formControl]="form.controls.priority_id"
            placeholder="Prio auswählen"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermPrio">
              @if (item.name.toLowerCase().includes(searchTermProject.toLowerCase())) {
                <div>
                  {{ item.name }}
                </div>
              }
            </ng-template>
          </ng-select>
        }
      </fieldset>
      <fieldset class="bm-fieldset p-4">
        @if (technicians.length > 0) {
          <label class="bm-fieldset-label">Techniker</label>
          <ng-select
            class="w-full"
            [items]="technicians"
            bindLabel="search_name"
            bindValue="id"
            [multiple]="true"
            [formControl]="form.controls.technician_ids"
          />
        }
        @if (companies.length > 0) {
          <label class="bm-fieldset-label">Firma Partner</label>
          <ng-select
            class="w-full"
            [items]="companies"
            bindLabel="company"
            bindValue="company"
            [multiple]="true"
            [formControl]="form.controls.technician_company_names"
          />
        }
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [formControl]="form.controls.is_open" />
          Nur offene Tickets
        </label>
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [formControl]="form.controls.not_invoiced" />
          Nicht abgerechnete Tickets
        </label>
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [formControl]="form.controls.not_invoiced_partner" />
          Nicht von Partnern abgerechnete Tickets
        </label>
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [formControl]="form.controls.has_date" />
          Nur Tickets mit Terminvereinbarung
        </label>
      </fieldset>
    </div>
    <div class="flex flex-row gap-2 justify-end">
      <button class="bm-btn bm-btn-primary rounded-2" (click)="search()">Suche starten</button>
    </div>
  </form>
</div>
